"use strict";
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};
module.exports = ReactCurrentOwner;
